import {
  BookOpenIcon,
  ClockClockWiseIcon,
  HouseIcon,
  PlayCircleIcon,
  RowsIcon,
} from "components/icons";
import { E_Route } from "utils/constants";

export const NAV_ITEMS = [
  {
    label: "Home",
    route: E_Route.Home,
    Icon: HouseIcon,
    freeDisabled: false,
    featureFlag: false,
  },
  {
    label: "Todos",
    route: E_Route.Todos,
    Icon: RowsIcon,
    freeDisabled: true,
    featureFlag: true,
  },
  {
    label: "Podcast",
    route: E_Route.Podcast,
    Icon: PlayCircleIcon,
    freeDisabled: true,
    featureFlag: false,
  },
  {
    label: "Meeting transcript",
    route: E_Route.Transcript,
    Icon: BookOpenIcon,
    freeDisabled: true,
    featureFlag: false,
  },
  //{
  //  label: "Calendar",
  //  route: E_Route.Calendar,
  //  Icon: CalendarBlankIcon,
  //  freeDisabled: true,
  //  featureFlag: false,
  //},
  {
    label: "Activity",
    route: E_Route.Activity,
    Icon: ClockClockWiseIcon,
    freeDisabled: false,
    featureFlag: false,
  },
];
